import React from 'react';
const TermsOfService = () => {
  return <div className="pt-32 pb-20 px-4 md:px-6" data-id="element-173">
      <div className="container mx-auto max-w-4xl" data-id="element-174">
        <h1 className="text-3xl md:text-4xl font-light mb-12 tracking-tight" data-id="element-175">
          Terms of Service
        </h1>
        <div className="prose prose-sm max-w-none" data-id="element-176">
          <p data-id="element-177">
            <strong data-id="element-178">Last Updated:</strong> {new Date().toLocaleDateString()}
          </p>
          <section className="mt-8" data-id="element-179">
            <h2 className="text-xl font-medium mb-4" data-id="element-180">1. Acceptance of Terms</h2>
            <p data-id="element-181">
              Welcome to the AI ad analysis and posting tool for Facebook (the
              "App") provided by Lienov Solutions LLC ("we," "our," or "us"). By
              accessing or using our App, you agree to be bound by these Terms
              of Service ("Terms"). If you do not agree to these Terms, please
              do not use the App.
            </p>
          </section>
          <section className="mt-8" data-id="element-182">
            <h2 className="text-xl font-medium mb-4" data-id="element-183">
              2. Description of Service
            </h2>
            <p data-id="element-184">
              The App provides AI-powered analysis of Facebook advertisements
              and automated posting capabilities. The App is intended for
              personal use and requires connection to a Facebook account to
              access certain features. We reserve the right to modify, suspend,
              or discontinue the App or any part thereof at any time without
              notice.
            </p>
          </section>
          <section className="mt-8" data-id="element-185">
            <h2 className="text-xl font-medium mb-4" data-id="element-186">
              3. Account Registration
            </h2>
            <p data-id="element-187">
              To use certain features of the App, you may need to create an
              account. You agree to provide accurate, current, and complete
              information during the registration process and to update such
              information to keep it accurate, current, and complete. You are
              responsible for safeguarding your password and for all activities
              that occur under your account. You agree to notify us immediately
              of any unauthorized use of your account.
            </p>
          </section>
          <section className="mt-8" data-id="element-188">
            <h2 className="text-xl font-medium mb-4" data-id="element-189">4. Facebook Connection</h2>
            <p data-id="element-190">
              The App requires connection to Facebook to analyze and post ads.
              By connecting your Facebook account, you authorize us to access
              and use certain Facebook account information in accordance with
              our Privacy Policy and Facebook's Platform Policy. You represent
              that you have the authority to connect your Facebook account to
              our App and to grant us the permissions requested.
            </p>
          </section>
          <section className="mt-8" data-id="element-191">
            <h2 className="text-xl font-medium mb-4" data-id="element-192">5. User Conduct</h2>
            <p data-id="element-193">You agree not to use the App to:</p>
            <ul className="list-disc pl-6 mt-4 space-y-2" data-id="element-194">
              <li data-id="element-195">
                Violate any applicable law, regulation, or Facebook's terms of
                service.
              </li>
              <li data-id="element-196">
                Create, upload, or distribute content that is illegal, harmful,
                threatening, abusive, or otherwise objectionable.
              </li>
              <li data-id="element-197">
                Impersonate any person or entity or falsely state or otherwise
                misrepresent your affiliation with a person or entity.
              </li>
              <li data-id="element-198">
                Interfere with or disrupt the App or servers or networks
                connected to the App.
              </li>
              <li data-id="element-199">
                Attempt to gain unauthorized access to the App, user accounts,
                or computer systems.
              </li>
              <li data-id="element-200">
                Collect or store personal data about other users without their
                consent.
              </li>
              <li data-id="element-201">
                Use the App for any commercial purpose without our prior written
                consent.
              </li>
            </ul>
          </section>
          <section className="mt-8" data-id="element-202">
            <h2 className="text-xl font-medium mb-4" data-id="element-203">
              6. Intellectual Property
            </h2>
            <p data-id="element-204">
              The App and its original content, features, and functionality are
              and will remain the exclusive property of Lienov Solutions LLC and
              its licensors. The App is protected by copyright, trademark, and
              other laws. Our trademarks and trade dress may not be used in
              connection with any product or service without the prior written
              consent of Lienov Solutions LLC.
            </p>
          </section>
          <section className="mt-8" data-id="element-205">
            <h2 className="text-xl font-medium mb-4" data-id="element-206">7. User Content</h2>
            <p data-id="element-207">
              You retain ownership of any content you submit, post, or display
              on or through the App ("User Content"). By submitting User
              Content, you grant us a worldwide, non-exclusive, royalty-free
              license to use, reproduce, modify, adapt, publish, translate, and
              distribute such content in connection with providing the App. You
              represent and warrant that you own or have the necessary rights to
              the User Content and that the User Content does not violate the
              rights of any third party.
            </p>
          </section>
          <section className="mt-8" data-id="element-208">
            <h2 className="text-xl font-medium mb-4" data-id="element-209">
              8. Disclaimer of Warranties
            </h2>
            <p data-id="element-210">
              THE APP IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES
              OF ANY KIND, EITHER EXPRESS OR IMPLIED. TO THE FULLEST EXTENT
              PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED,
              INCLUDING IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
              PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE DO NOT WARRANT THAT
              THE APP WILL BE UNINTERRUPTED, ERROR-FREE, OR SECURE, THAT DEFECTS
              WILL BE CORRECTED, OR THAT THE APP IS FREE OF VIRUSES OR OTHER
              HARMFUL COMPONENTS.
            </p>
          </section>
          <section className="mt-8" data-id="element-211">
            <h2 className="text-xl font-medium mb-4" data-id="element-212">
              9. Limitation of Liability
            </h2>
            <p data-id="element-213">
              TO THE MAXIMUM EXTENT PERMITTED BY LAW, IN NO EVENT SHALL LIENOV
              SOLUTIONS LLC, ITS AFFILIATES, DIRECTORS, EMPLOYEES, OR AGENTS BE
              LIABLE FOR ANY INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL,
              CONSEQUENTIAL, OR EXEMPLARY DAMAGES, INCLUDING WITHOUT LIMITATION
              DAMAGES FOR LOSS OF PROFITS, GOODWILL, USE, DATA, OR OTHER
              INTANGIBLE LOSSES, THAT RESULT FROM THE USE OF, OR INABILITY TO
              USE, THE APP. UNDER NO CIRCUMSTANCES WILL OUR AGGREGATE LIABILITY
              EXCEED THE GREATER OF ONE HUNDRED DOLLARS ($100) OR THE AMOUNT YOU
              HAVE PAID US IN THE PAST SIX MONTHS.
            </p>
          </section>
          <section className="mt-8" data-id="element-214">
            <h2 className="text-xl font-medium mb-4" data-id="element-215">10. Indemnification</h2>
            <p data-id="element-216">
              You agree to defend, indemnify, and hold harmless Lienov Solutions
              LLC, its affiliates, directors, employees, and agents from and
              against any and all claims, damages, obligations, losses,
              liabilities, costs, and expenses (including attorney's fees)
              arising from: (a) your use of the App; (b) your violation of these
              Terms; (c) your violation of any third-party right, including
              without limitation any copyright, property, or privacy right; or
              (d) any claim that your User Content caused damage to a third
              party.
            </p>
          </section>
          <section className="mt-8" data-id="element-217">
            <h2 className="text-xl font-medium mb-4" data-id="element-218">11. Termination</h2>
            <p data-id="element-219">
              We may terminate or suspend your account and access to the App
              immediately, without prior notice or liability, for any reason
              whatsoever, including without limitation if you breach these
              Terms. Upon termination, your right to use the App will
              immediately cease. All provisions of these Terms which by their
              nature should survive termination shall survive termination,
              including, without limitation, ownership provisions, warranty
              disclaimers, indemnity, and limitations of liability.
            </p>
          </section>
          <section className="mt-8" data-id="element-220">
            <h2 className="text-xl font-medium mb-4" data-id="element-221">12. Governing Law</h2>
            <p data-id="element-222">
              These Terms shall be governed and construed in accordance with the
              laws of the State of Florida, without regard to its conflict of
              law provisions. Any dispute arising from or relating to these
              Terms or your use of the App shall be subject to the exclusive
              jurisdiction of the state and federal courts located in Miami-Dade
              County, Florida.
            </p>
          </section>
          <section className="mt-8" data-id="element-223">
            <h2 className="text-xl font-medium mb-4" data-id="element-224">13. Changes to Terms</h2>
            <p data-id="element-225">
              We reserve the right, at our sole discretion, to modify or replace
              these Terms at any time. We will provide notice of any changes by
              posting the new Terms on the App. Your continued use of the App
              after any such changes constitutes your acceptance of the new
              Terms.
            </p>
          </section>
          <section className="mt-8" data-id="element-226">
            <h2 className="text-xl font-medium mb-4" data-id="element-227">14. Contact Us</h2>
            <p data-id="element-228">
              If you have any questions about these Terms, please contact us at:
            </p>
            <p className="mt-4" data-id="element-229">
              Lienov Solutions LLC
              <br data-id="element-230" />
              19390 Collins Avenue, Unit 1009
              <br data-id="element-231" />
              Sunny Isles Beach, FL 33160
              <br data-id="element-232" />
              Email: nikitalienov@gmail.com
            </p>
          </section>
        </div>
      </div>
    </div>;
};
export default TermsOfService;